import modalErrorMap from 'App/Services/Localizations/modalError/modalErrorMap';

/**
 * Localized title/body shown when legal CMS content cannot be loaded.
 *
 * @param {string} lang - Lang key of `modalErrorLocalizations.json` (e.g. `en`, `gr`, `enza`).
 * @returns {{ title: string, content: string }}
 */
export function getLegalErrorCopy(lang) {
    const copy = modalErrorMap[lang];

    return {
        title: copy.errorTitle,
        content: `<div class='error-text'>${copy.contentError}</div>`,
    };
}
